// ─── Role-based inactivity session timeouts ───────────────────────────────
// Change these values to adjust how long each role stays logged in
// when there is no mouse, keyboard, or click activity.

export const SESSION_TIMEOUTS = {
  admin:   8 * 60 * 60 * 1000,   // 8 hours  — admin can work a full shift
  manager: 4 * 60 * 60 * 1000,   // 4 hours  — manager rostering sessions
  staff:   10 * 60 * 1000,        // 10 minutes — unchanged
};

/**
 * Returns the inactivity timeout in milliseconds for the given userInfo object.
 * Admin takes priority over Manager if a user happens to have both flags set.
 */
export const getTimeoutForUser = (userInfo) => {
  if (!userInfo) return SESSION_TIMEOUTS.staff;
  if (userInfo.isAdmin)   return SESSION_TIMEOUTS.admin;
  if (userInfo.isManager) return SESSION_TIMEOUTS.manager;
  return SESSION_TIMEOUTS.staff;
};